/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { stopEvent } from './events.js';
export function focusable(element) {
    return element.matches([
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'button:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'iframe',
        'object',
        'embed',
        '*[tabindex]',
        '*[contenteditable=true]',
        '[role=button]:not([disabled])',
    ].join(','));
}
// todo cory: test
/**
 * Lists simple focus primitives, any interactive element that does not require advanced keyboard interactions like arrow/navigation
 */
export function simpleFocusable(element) {
    return element.matches([
        'a[href]',
        'button:not([disabled])',
        'input[type=checkbox]',
        'input[type=radio]',
        'object',
        'embed',
        '*[tabindex]',
        '[role=button]:not([disabled])',
    ].join(','));
}
export function getActiveElement(root = document) {
    if (root.activeElement && root.activeElement.shadowRoot) {
        return getActiveElement(root.activeElement.shadowRoot) ?? root.activeElement;
    }
    else {
        return root.activeElement;
    }
}
export function focusElement(element) {
    if (element && !focusable(element)) {
        element.setAttribute('tabindex', '-1');
        element.focus();
        element.addEventListener('blur', () => element.removeAttribute('tabindex'), { once: true });
    }
    else {
        element?.focus();
    }
}
export function onFocusOut(element, fn) {
    element.addEventListener('focusout', (event) => {
        if (!element.contains(event.relatedTarget) && document.hasFocus()) {
            fn();
        }
    });
}
export function onEscape(element, fn) {
    element.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
            stopEvent(e);
            fn();
        }
    });
}
export function ignoreFocus(hostEl) {
    return (hostEl.cdsIgnoreFocus === true ||
        hostEl.hasAttribute('cds-ignore-focus') ||
        hostEl.hasAttribute('_demo-mode') // deprecated internal
    );
}
// todo cory: test
export function setActiveKeyListItem(items, item) {
    items.forEach(i => (i.tabIndex = -1));
    item.tabIndex = 0;
}
// todo cory: test
export function initializeKeyListItems(items) {
    items.forEach(i => (i.tabIndex = -1));
    items[0].tabIndex = 0;
}
